import { type Field } from "~/types/jben/job_post";

const STANDARD_FIELDS: Readonly<Set<string>> = Object.freeze(
  new Set(["first_name", "last_name", "email", "preferred_name", "phone", "candidate_location"])
);

// This function should be updated as we add new supported fields to autofill.
// Any autofillable, focusable field should cause this function to return true.
export function shouldTriggerMagicAutofill(field: Field): boolean {
  return STANDARD_FIELDS.has(field.name);
}
